import React from "react";
import "./PopupDialog.css";
import Button from "./Button";

const PopupDialog = (props) => {
    const { 
        text, 
        message, 
        onCancel, 
        onConfirm, 
        show, 
        type, 
        okLabel, 
        cancelLabel,
        dialogTitle,
        data
     } = props;

    switch (type) {
        case "confirmation":
            return (
                show && (
                    <div className="delete-popup-overlay">
                        <div className="delete-popup">
                            <h2>{dialogTitle}</h2>
                            <div className="confirmationDialogBody">
                                <p>{message}</p>
                                <p><b>{data}</b></p>
                            </div>
                            <div className="popup-buttons">
                                    <Button
                                        type="Delete-Cancel-btn"
                                        label={cancelLabel}
                                        onClick={onCancel}
                                        buttonType="button"
                                    />
                                    <Button
                                        type="Delete-Ok-btn"
                                        label={okLabel}
                                        onClick={onConfirm}
                                        buttonType="button"
                                    />
                                </div>
                        </div>
                    </div>
                )
            );
        case "success":
        case "error":
            return (
                <div className={type === "success" ? "success-message" : "error-message"}>
                    {text}
                </div>
            )
        case "popup":
            return (
                show && (
                    <div className="popup-backdrop">
                        <div className="popup-box">
                            <p>{message}</p>
                            <Button
                                type="ok-btn"
                                label={okLabel}
                                onClick={onConfirm}
                                buttonType="button"
                            />
                        </div>
                    </div>
                )
            )
        default:
            return null;
    }
};

export default PopupDialog;
